// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_TopupInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Staff topup request body — Full-gated.
 *
 * Required fields:
 *   franquia_id  (int)    — target franchise
 *   micro_credits (int)   — amount to credit (must be > 0)
 *   request_id   (string) — caller-supplied idempotency key
 *
 * Optional:
 *   note  (string|null)   — staff note, stored in ledger meta
 */
import { registerContract } from './validate'

export interface AiCredits_TopupInput {
franquia_id: number
micro_credits: number
request_id: string
note?: string
}

registerContract('AiCredits_TopupInput', {
  franquia_id:   { type: 'number',  required: true },
  micro_credits: { type: 'number',  required: true },
  request_id:    { type: 'string',  required: true },
  note:          { type: 'string',  required: false },
})
